export default __webpack_public_path__ + "static/media/mobile.56c531d1.svg";